module.exports = __webpack_public_path__ + "img/2_103.4ca8b0da.png";